import { createFileRoute, Outlet } from "@tanstack/react-router";
import { GlobalInitDataContextProvider } from "src/contexts/GlobalInitDataContextProvider.tsx";
import { UserEventsContextProvider } from "src/userEvents/UserEventsContextProvider.tsx";
import { AiAssistantContextProvider } from "src/components/views/ai/assistant/AiAssistantContextProvider.tsx";
import { ConfirmDialogProvider } from "src/components/common/dialogs/confirmDialog/ConfirmDialogContextProvider.tsx";
import { MessageDialogContextProvider } from "src/components/common/dialogs/messageDialog/MessageDialogContextProvider.tsx";

/** Pages that need a signed-in user. */
export const Route = createFileRoute("/_authenticated")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<GlobalInitDataContextProvider>
			<UserEventsContextProvider>
				<AiAssistantContextProvider>
					<ConfirmDialogProvider>
						<MessageDialogContextProvider>
							<Outlet />
						</MessageDialogContextProvider>
					</ConfirmDialogProvider>
				</AiAssistantContextProvider>
			</UserEventsContextProvider>
		</GlobalInitDataContextProvider>
	);
}
